import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearSolicitud = async (solicitud) => {
    try {
        if (solicitud.id) {
            const resp = await axios.put(
                `${API_URL}/solicitudes/solicitud/${solicitud.id}`,
                solicitud,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/solicitudes/soporte`,
            solicitud,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectLugaresPorSede = async (sedeId) => {
    try {
        const resp = await axios.get(
            `${API_URL}/lugares/select/${sedeId}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectCiudades = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/ciudad/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTiposSolicitudes = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/tiposSolicitudes/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarSolicitud = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/solicitudes/asignar/${data.solicitud_id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const verAsignacionSolicitud = async (id_solicitud) => {
    try {
        const resp = await axios.get(`${API_URL}/solicitudes/${id_solicitud}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};


export const reAsignarSolicitud = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/solicitudes/reasignar/${data.solicitud_id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectSolictudesPorColaborador = async (id_colaborador) => {
    try {
        const resp = await axios.get(`${API_URL}/solicitudes/selectSolicitudColaborador/${id_colaborador}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectProveedoresByArea = async (area_id) => {
    try {
        const resp = await axios.get(
            `${API_URL}/proveedores/select/${area_id}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};